import { Size } from '@modusign/react-signing/types';

import {
  AbsoluteNumber,
  AbsolutePoint,
  AbsoluteSize,
  Point,
} from '@app/features/apply-react-signing/components/FieldRenderer/types';

export function toRelativePoint(absolutePoint: AbsolutePoint, viewport: AbsoluteSize): Point {
  return {
    x: absolutePoint.x / viewport.width,
    y: absolutePoint.y / viewport.height,
  };
}

export function toRelativeSize(absoluteSize: AbsoluteSize, viewport: AbsoluteSize): Size {
  return {
    width: absoluteSize.width / viewport.width,
    height: absoluteSize.height / viewport.height,
  };
}

export function toAbsoluteNumber(size: number, viewport: AbsoluteSize): AbsoluteNumber {
  return (size * viewport.width) as AbsoluteNumber;
}

export function toAbsolutePoint(relativePoint: Point, viewport: AbsoluteSize): AbsolutePoint {
  return {
    x: relativePoint.x * viewport.width,
    y: relativePoint.y * viewport.height,
  } as AbsolutePoint;
}

export function toAbsoluteSize(relativeSize: Size, viewport: AbsoluteSize): AbsoluteSize {
  return {
    width: relativeSize.width * viewport.width,
    height: relativeSize.height * viewport.height,
  } as AbsoluteSize;
}
